import { render } from "./DashboardCompany.vue?vue&type=template&id=266ef1ba"
import script from "./DashboardCompany.vue?vue&type=script&lang=js"
export * from "./DashboardCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__